'use strict';
Groupon.verifyUserCookies = function() {
  return setTimeout((function() {
    var el, ref, src;
    if (!(src = Groupon.endpoints.verifyCookies)) {
      return;
    }
    if ((ref = window.sessionStorage) != null ? ref.getItem('verifiedCookies') : void 0) {
      return;
    }
    el = document.createElement('script');
    el.id = 'verify_cookies';
    el.async = true;
    document.body.appendChild(el).src = src;
    try {
      return typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.setItem('verifiedCookies', true) : void 0;
    } catch (error) {}
  }), 0);
};

